/**
 * ForbiddenPage — 403 Access Denied page.
 * Shown when a user tries to access a route their role doesn't allow.
 */
import { Link } from 'react-router-dom'
import { ShieldX } from 'lucide-react'
import { useAuth } from '@/stores/auth-context'
import type { UserRole } from '@/api/types'

const ROLE_HOME: Record<UserRole, string> = {
  admin: '/admin',
  student: '/dashboard',
}

export default function ForbiddenPage() {
  const { user } = useAuth()
  const homeLink = user ? ROLE_HOME[user.role] : '/'

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <ShieldX className="mx-auto text-destructive" style={{ width: 48, height: 48 }} />
        <h1 className="text-2xl font-bold text-foreground">403 - Access Denied</h1>
        <p className="text-sm text-muted-foreground max-w-md">
          You don't have permission to access this page.
        </p>
        <Link
          to={homeLink}
          className="inline-block mt-4 px-4 py-2 text-sm font-medium text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 transition-colors"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  )
}
